'use client';

import { ActivityItem, Separator } from '@/_components';
import { Fragment, type FC } from 'react';
import styles from './ActivitiesList.module.css';
import type { ActivitiesListProps } from './ActivitiesList.types';

export const ActivitiesList: FC<ActivitiesListProps> = ({ activities }) => {
  if (!activities?.length) return null;

  return activities?.map((activityLog, key) => {
    const isLast = key !== activities.length - 1;

    return (
      <Fragment key={key}>
        <ActivityItem key={key} activityLog={activityLog} />
        {isLast && (
          <Separator
            isLight={true}
            className={styles.activitiesList__separator}
          />
        )}
      </Fragment>
    );
  });
};
